/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes.js';

// Lazy loading works with the bundles; loads only the new chunk. There is a flash in the UI though.
const AddHomeCountry = React.lazy(() => import('../AddHomeCountry/AddHomeCountry'));
const AddMobilePhone = React.lazy(() => import('../AddMobilePhone/AddMobilePhone'));
const SignIn = React.lazy(() => import('../SignIn/SignIn'));
const CreateAccount = React.lazy(() => import('../CreateAccount/CreateAccount'));
const ResetPassword = React.lazy(() => import('../ResetPassword/ResetPassword'));
const ForgotUserNamePwd = React.lazy(() => import('../ForgotUserPwd/ForgotUserPwd'));
const Consents = React.lazy(() => import('../Consents/Consents'));
const SessionEnded = React.lazy(() => import('../SessionEnded/SessionEnded'));
const VerifyEmailEscrowExpired = React.lazy(() => import('../VerifyEmailEscrowExpired/VerifyEmailEscrowExpired'));
const VerifyMFARecaptcha = React.lazy(() => import('../VerifyMFARecaptcha/VerifyMFARecaptcha'));
const AuoWelcome = React.lazy(() => import('../AuoWelcome/AuoWelcome'));
const CreatePassword = React.lazy(() => import('../CreatePassword/CreatePassword'));
const VerifyMobilePhoneForgot = React.lazy(() => import('../VerifyMobilePhoneForForgot/VerifyMobilePhoneForForgot'));
const SecurityQuestions = React.lazy(() => import('../SecurityQuestions/SecurityQuestions'));
const VerifyMobilePhone = React.lazy(() => import('../VerifyMobilePhone/VerifyMobilePhone'));
const ResetPasswordLinks = React.lazy(() => import('../ResetPasswordLinks/ResetPasswordLinks'));
const ChooseAccountType = React.lazy(() => import('../ChooseAccountType/ChooseAccountType'));
const LinkAccounts = React.lazy(() => import('../LinkAccounts/LinkAccounts'));
const LinkAccountsError = React.lazy(() => import('../LinkAccountsError/LinkAccountsError'));
const LinkAccountsConfirmation = React.lazy(() => import('../LinkAccountConfirmation/LinkAccountConfirmation'));
const MFAOptions = React.lazy(() => import('../MFAOptions/MFAOptions'));

function MainContent() {
  const location = useLocation();
  const [isE2EScriptLoaded, setIsE2EScriptLoaded] = useState<boolean>(false);

  useEffect(() => {
    // Check if all script Loaded For
    const scriptLoadedHandler = () => {
      setIsE2EScriptLoaded(true);
    };
    window.addEventListener('load', scriptLoadedHandler);
    return () => {
      window.removeEventListener('load', scriptLoadedHandler);
    };
  }, [location.pathname]);

  useEffect(() => {
    if (!isE2EScriptLoaded) return;
    const wrapper = document.getElementById('e2e-comms-wrapper');
    try {
      if (location.pathname === ROUTES.LOGIN_INTERNAL) {
        window._e2e_comms?.add(wrapper);
      } else {
        window._e2e_comms?.remove(wrapper);
      }
    } catch (e) {
      console.log(e);
    }
  }, [location.pathname, isE2EScriptLoaded]);
  return (
    <div className="main-page-content" role="main">
      <Routes>
        <Route path={ROUTES.LOGIN_INTERNAL} element={<SignIn />} />
        <Route
          path={ROUTES.CREATE_ACCOUNT_LINK_ACCOUNTS_INTERNAL}
          element={<CreateAccount pageState="LinkAccount" />}
        />
        <Route path={ROUTES.CREATE_ACCOUNT_INTERNAL} element={<CreateAccount />} />
        <Route path={ROUTES.CONSENTS_INTERNAL} element={<Consents />} />
        <Route path={ROUTES.SESSION_ENDED_INTERNAL} element={<SessionEnded />} />
        <Route path={ROUTES.VERIFY_EMAIL_ESCROW_EXPIRED_INTERNAL} element={<VerifyEmailEscrowExpired />} />
        <Route path={ROUTES.RESET_PW_INTERNAL} element={<ResetPassword />} />
        <Route path={ROUTES.FORGOT_UN_PW_INTERNAL} element={<ForgotUserNamePwd />} />
        <Route path={ROUTES.UNVERIFIED_RECAPTCHA} element={<MFAOptions />} />
        <Route path={ROUTES.SOCIAL_LOGIN} element={<SignIn />} />
        <Route path={ROUTES.SOCIAL_LOGIN_CR} element={<CreateAccount />} />
        <Route path={ROUTES.AUO_WELCOME} element={<AuoWelcome />} />
        <Route path={ROUTES.CREATE_PW} element={<CreatePassword />} />
        <Route path={ROUTES.ADD_HOME_COUNTRY} element={<AddHomeCountry />} />
        <Route path={ROUTES.ADD_MOBILE_PHONE} element={<AddMobilePhone />} />
        <Route path={ROUTES.VERIFY_MOBILE_PHONE_FOR_FORGOT} element={<VerifyMobilePhoneForgot />} />
        <Route path={ROUTES.SECURITY_QUESTIONS} element={<SecurityQuestions />} />
        <Route path={ROUTES.VERIFY_MOBILE_PHONE} element={<VerifyMobilePhone />} />
        <Route path={ROUTES.VERIFY_MFA_RECAPTCHA} element={<VerifyMFARecaptcha />} />
        <Route path={ROUTES.RESET_PW_LINKS} element={<ResetPasswordLinks />} />
        <Route path={ROUTES.CHOOSE_ACCOUNT_TYPE_INTERNAL} element={<ChooseAccountType />} />
        <Route path={ROUTES.LINK_ACCOUNTS} element={<LinkAccounts />} />
        <Route path={ROUTES.LINK_ACCOUNTS_ERROR} element={<LinkAccountsError />} />
        <Route path={ROUTES.LINK_ACCOUNTS_CONFIRMATION} element={<LinkAccountsConfirmation />} />

        <Route path="*" element={<SignIn />} />
      </Routes>
    </div>
  );
}

export default MainContent;
